import { useContext } from "react";
import { StoreContext } from "../store/Store";
import { actionTypes } from "../store/storeTypes";
import RightArrow from "../images/svg/RightArrow";

export const PopupLabel = ({ data }) => {
  const [store, dispatch] = useContext(StoreContext);
  const { flowConfig ,popup} = store;

  return data.hoverLabel ? (
    <div
      style={{
        ...data.popupStyle.label,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      onClick={() => {
        dispatch({
          type: actionTypes.SET_POPUP,
          payload: { active: !popup.active, content: data.hoverText },
        });
      }}
    >
      <div>{data.hoverLabel}</div>
      <RightArrow
        width={flowConfig.popupLabelArrowWidth}
        height={flowConfig.popupLabelArrowWidth}
        fill={flowConfig.popupLabelArrowColor}
      />
    </div>
  ) : null;
};
